import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";

export function useTabParam(paramName: string, defaultTab: string) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const currentTab = searchParams.get(paramName) || defaultTab;

  const setTab = useCallback(
    (newValue: string) => {
      const params = new URLSearchParams(searchParams);
      params.set(paramName, newValue.toLowerCase().replace(/\s+/g, "-"));
      router.push(`${pathname}?${params.toString()}`);
    },
    [router, pathname, searchParams, paramName]
  );

  return {
    currentTab,
    setTab,
  };
}
